<template>
  <sections-extra-layout>
    <template slot="title">Trigger</template>
    <template slot="description">Define when this {{ type }} launches.</template>
    <template slot="content">
      <div>
        <p class="font-bold mb-4">When should this {{ type }} launch?</p>
        <div class="mt-2">
          <label class="cursor-pointer w-full mb-4 inline-flex items-center ml-6">
            <input
              type="radio"
              class="form-radio"
              name="mode_frequency"
              @change="setEverytime()"
              value="allow"
              :checked="frequency !== 'never'"
            />
            <span class="ml-2">When the user reaches the page</span>
          </label>
          <label class="cursor-pointer w-full mb-2 inline-flex items-center ml-6">
            <input
              type="radio"
              class="form-radio"
              name="frequency"
              @change="setNever()"
              :checked="frequency == 'never'"
            />
            <span class="ml-2">Only manually (from permalink, RF function)</span>
          </label>
        </div>
      </div>

      <div v-if="frequency !== 'never'">
        <div v-if="type === 'Survey'">
          <div class="flex">
            <p class="font-bold mb-4 mt-2">When the NPS will pop?</p>
          </div>
          <div class="mt-2">
            <span class="font-semibold text-gray-500" v-if="answered === 0 && seen === 0">Nps will pop  all the time</span>
            <span class="font-semibold text-gray-500" v-else-if="seen === 0">Nps will pop until the user answers.  Next pop will happen <span class="font-semibold text-gray-500" v-if="answered > 1">{{ answered }} days</span><span class="font-semibold text-gray-500" v-else>a day</span> after last answer</span>
            <span class="font-semibold text-gray-500" v-else-if="answered === 0">Nps will pop every <span class="font-semibold text-gray-500" v-if="seen > 1">{{ seen }} days</span><span class="font-semibold text-gray-500" v-else>a day</span> even if it's already answered</span>
            <span class="font-semibold text-gray-500" v-else>Nps will pop every <span class="font-semibold text-gray-500" v-if="seen > 1">{{ seen }} days</span><span class="font-semibold text-gray-500" v-else>day</span> and <span class="font-semibold text-gray-500" v-if="answered > 1">{{ answered }} days</span><span class="font-semibold text-gray-500" v-else>a day</span> after the last answer</span>
          </div>
          <div class="mt-2">
            <label class="cursor-pointer w-full mb-4 inline-flex ml-6">
              <input
                v-model="frequency"
                type="radio"
                class="form-radio"
                @change="setSometimes()"
                name="frequency"
                value="sometimes"
              />
              <div>
                <div>
                  <span class="ml-2">
                    Minimum interval between two views:
                    <input
                      type="number"
                      min="0"
                      @change="setSometimes()"
                      v-model.number="seen"
                      class="text-center mx-2 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-16"
                      value="1"
                    />
                    day(s)
                  </span>
                  <span class="ml-2">
                    / Minimum interval between two answers:
                    <input
                      type="number"
                      min="0"
                      @change="setSometimes()"
                      v-model.number="answered"
                      class="text-center mx-2 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-16"
                      value="1"
                    />
                    day(s)
                  </span>
                </div>
              </div>
            </label>
            <label class="cursor-pointer w-full mb-2 inline-flex items-center ml-6">
              <input
                v-model="frequency"
                type="radio"
                class="form-radio"
                @change="setEverytime()"
                value="everytime"
                name="frequency"
              />
              <span class="ml-2">Show every time</span>
            </label>
          </div>
        </div>
        <div v-else>
          <p class="font-bold mb-4">And how often?</p>
          <div class="mt-2">
            <label class="cursor-pointer w-full mb-4 inline-flex items-center ml-6">
              <input
                v-model="frequency"
                type="radio"
                class="form-radio"
                @change="setSometimes()"
                name="frequency"
                value="sometimes"
              />
              <span class="ml-2">
                Show
                <input
                  type="number"
                  min="0"
                  @change="setSometimes()"
                  v-model.number="recurrence"
                  class="text-center mx-2 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-16"
                  value="1"
                />
                per
                <select
                  v-model="period"
                  @change="setSometimes()"
                  name="type"
                  class="cursor-pointer mx-2 text-center mx-2 px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"
                >
                  <option value="hour">hour</option>
                  <option value="day">day</option>
                  <option value="week">week</option>
                  <option value="month">month</option>
                  <option value="none">none</option>
                </select>
              </span>
            </label>
            <label class="cursor-pointer w-full mb-2 inline-flex items-center ml-6">
              <input
                v-model="frequency"
                type="radio"
                class="form-radio"
                @change="setEverytime()"
                value="everytime"
                name="frequency"
              />
              <span class="ml-2">Show every time</span>
            </label>
          </div>
        </div>
      </div>
    </template>
  </sections-extra-layout>
</template>

<script>
export default {
  name: 'Trigger',
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fields: null,
      frequency: null,
      frequencylimitationvalue: null,
      frequencylimitation: null,
      seen: 2,
      answered: 5,
      displayintervaldelayseen: null,
      displayintervaldelayanswered: null,
      targetObject: {},
      recurrence: 1,
      period: 'day'
    }
  },
  computed: {
    frequencyKeys() {
      return ['frequency', 'frequencylimitationvalue', 'frequencylimitation']
    }
  },
  methods: {
    emitFrequencies() {
      this.frequencyKeys.forEach(key => {
        if (key) {
          this.$emit(`update-${key}`, this[key])
        }
      })
      if (this.type === 'Survey') {
        this.$emit(`update-displayintervaldelayseen`, this.displayintervaldelayseen)
        this.$emit(`update-displayintervaldelayanswered`, this.displayintervaldelayanswered)
      }
    },

    setSometimes() {
      this.frequencylimitation = this.period
      this.frequencylimitationvalue = this.recurrence
      this.frequency = 'sometimes'
      if (this.type === 'Survey') {
        this.displayintervaldelayseen = this.seen
        this.displayintervaldelayanswered = this.answered
      }
      this.emitFrequencies()
    },

    setNever() {
      this.frequencylimitation = 'none'
      this.frequencylimitationvalue = 0
      this.frequency = 'never'
      this.emitFrequencies()
    },

    setEverytime() {
      this.frequencylimitation = 'none'
      this.frequencylimitationvalue = 0
      this.recurrence = 0
      this.seen = 0
      this.displayintervaldelayseen = 0
      this.answered = 0
      this.displayintervaldelayanswered = 0
      this.frequency = 'everytime'
      this.emitFrequencies()
    },
  },
  created() {
    if (this.data) {
      this.targetObject = this.data
    }
    if (this.targetObject) {
      if (this.targetObject.frequencylimitation) {
        this.frequencylimitation = this.targetObject.frequencylimitation
      }
      if (this.targetObject.frequencylimitationvalue) {
        this.frequencylimitationvalue = this.targetObject.frequencylimitationvalue
      }

      if (this.targetObject.frequencylimitation === 'none' && this.targetObject.frequencylimitationvalue === 0) {
        this.frequency = 'never'
      } else if (this.targetObject.frequencylimitation === 'none' && this.targetObject.frequencylimitationvalue === 1) {
        this.frequency = 'everytime'
      } else {
        this.frequency = 'sometimes'
        this.recurrence = this.targetObject.frequencylimitationvalue
        this.period = this.targetObject.frequencylimitation
        if (this.type === 'Survey') {
          this.seen = this.targetObject.displayintervaldelayseen
          this.answered = this.targetObject.displayintervaldelayanswered
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ui/form/trigger.vue